import { useAppStore } from '../stores/appStore'

export function getDefaultProduct(): string {
  const appStore = useAppStore()

  if (appStore.configuration?.components.productSelect) {
    if (
      appStore.selectedProduct &&
      appStore.configuration?.components.productSelect.availableProducts.includes(
        appStore.selectedProduct
      )
    ) {
      return appStore.selectedProduct
    }
    if (appStore.configuration?.components.productFromUrl.enabled && appStore.productFromUrl) {
      return appStore.productFromUrl
    }
    if (appStore.configuration?.components.productSelect.defaultProduct) {
      return appStore.configuration!.components.productSelect.defaultProduct
    }
    if (appStore.configuration?.components.productSelect.availableProducts.length > 0) {
      return appStore.configuration!.components.productSelect.availableProducts[0]
    }
  }
  return ''
}

export function setProduct(value: string | null): void {
  const appStore = useAppStore()

  appStore.setSelectedProduct(
    value ?? appStore.configuration?.components.productSelect.defaultProduct ?? ''
  )
}
